<template>
  <a-layout style="min-height: 100vh" v-if="$store.state.admin.isSignin">
    <a-layout-sider collapsible v-model="collapsed">
      <div class="logo" :style="collapsed ? 'height: 3%' : ''" @click="$router.push('/admin')" />
      <a-menu theme="dark" :defaultSelectedKeys="[$router.currentRoute.name]" mode="inline">
        <a-menu-item key="AdminDashboard" @click="$router.push('/admin')">
          <a-icon type="home" />
          <span>대시보드</span>
        </a-menu-item>
        <a-menu-item key="AdminUsers" @click="$router.push('/admin/users')">
          <a-icon type="user" />
          <span>사용자</span>
        </a-menu-item>
        <a-menu-item key="AdminUncles" @click="$router.push('/admin/uncles')">
          <a-icon type="team" />
          <span>사입 삼촌</span>
        </a-menu-item>
        <a-menu-item key="AdminQuestion" @click="$router.push('/admin/question')">
          <a-icon type="customer-service" />
          <span>1:1 문의</span>
        </a-menu-item>
        <a-menu-item key="AdminLocation" @click="$router.push('/admin/location')">
          <a-icon type="radar-chart" />
          <span>장소</span>
        </a-menu-item>
        <a-menu-item @click="adminSignout">
          <a-icon type="logout" />
          <span>로그아웃</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-card>
        <b>이름:</b>
        {{ $store.state.admin.name }}({{
        $store.state.admin.identity
        }})
        <br v-if="!isPC" />
        <b>잔액:</b>
        {{ $store.state.admin.amount.toLocaleString() }}원
        <br v-if="!isPC" />
        <b>만료일:</b>
        <span style="margin-left: 5px;" v-if="isPC">{{ $store.state.admin.expiry.format('llll') }}</span>
        <span style="margin-left: 5px;" v-else>{{ $store.state.admin.expiry.fromNow() }}</span>
        <br v-if="!isPC" />
        <b :style="isPC ? 'margin-left: 10px;' : ''">주소:</b>
        <span
          style="margin-left: 5px;"
          :href="`http://${$store.state.admin.hostname}`"
        >https://{{ $store.state.admin.hostname}}</span>
        <a-button size="large" type="link" shape="circle" icon="reload" @click="adminRefreshMe" />
      </a-card>
      <a-layout-content style="margin: 0 16px">
        <a-breadcrumb style="margin: 16px 0">
          <slot name="breadcrumb" />
        </a-breadcrumb>
        <div
          :style="{
            padding: '12px',
            background: color ? '#f0f2f5' : '#fff',
            minHeight: '360px'
          }"
        >
          <div :style="{ marginBottom: color ? '' : '30px' }">
            <p style="font-size: 150%">{{ title }}</p>
            <span style="font-size: 100%">{{ description }}</span>
          </div>
          <slot />
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center">Copyright 2020. 브로 사입 all rights reserved.</a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "TheHeader",
  methods: mapActions(["adminRefreshMe", "adminSignout"]),
  props: ["title", "description", "color"],
  data() {
    return { collapsed: !this.isPC };
  },
  mounted() {
    this.adminRefreshMe();
  }
};
</script>
<style>
.logo {
  height: 4.2em;
  width: auto;
  background-image: url("/assets/images/static/img_logo_type2.png");
  background-repeat: no-repeat;
  background-size: 100%;
  margin: 16px;
}
</style>
